import { ReactNode } from 'react';
import { TableRow, TableRowOwnProps } from '@mui/material';

interface DataTableProps extends TableRowOwnProps {
  children: ReactNode;
  role?: React.AriaRole;
  tabIndex?: number | undefined;
  droppableRef?: (element: HTMLElement | null) => void;
  onClick?: () => void;
}

export const DataTableRow = ({ children, role, tabIndex, droppableRef, onClick, ...props }: DataTableProps) => (
  <TableRow
    role={role}
    tabIndex={tabIndex}
    onClick={onClick}
    ref={droppableRef}
    sx={{
      borderBottom: '1px solid #e0e0e0',
      maxHeight: '56px',

      '&:first-of-type': {
        borderTop: '1px solid #e0e0e0',
      },
    }}
    {...props}
  >
    {children}
  </TableRow>
);

